<template>
  <div class="show_order">
    <div class="order-wrap">
      <div class="top_steps">
        <span class="click_point" @click="goToIndex">{{
          TLang("演出首页", "my")
        }}</span>
        <span class="top_arrow_icon">
          <img :src="staticAssets.ImgObj.arrow_right" alt />
        </span>
        <span>{{ TLang("订单详情", "list") }}</span>
      </div>
      <div class="ticket_pay_state">
        <div class="pay_state_img">
          <img :src="orderImg.wait_pay" alt />
        </div>
        <div class="pay_state_content">
          <div class="state_content_top">
            <span class="content_top_label">{{ getPayStatus(pay_state) }}</span>
            <img
              :src="staticAssets.ImgObj.pay_wait_time"
              alt
              v-if="pay_state == 1"
            />
            <span class="content_top_paytime" v-if="pay_state == 1">{{
              TLang("剩余支付时间", "my")
            }}</span>
            <span class="content_top_time" v-if="pay_state == 1">{{
              wait_pay_time
            }}</span>
            <span
              class="content_top_paytime pay_state_cancel"
              v-if="pay_state == 4"
              >{{ order_statusName }}</span
            >
          </div>
          <div
            class="state_content_bottom"
            v-if="detailSourceData.mallShowGoodsOrderDtoList"
          >
            <span
              class="content_bottom_label"
              v-if="
                detailSourceData.supplierOrderNo &&
                detailSourceData.issueTickType == 1 &&
                detailSourceData.deliveryType == 4
              "
              >{{TLang(detailSourceData.supplierCode == 1 ? '大麦订单号' : '猫眼订单号','my')}}：</span
            >
            <span
              style="margin-right: 32px"
              v-if="
                detailSourceData.supplierOrderNo &&
                detailSourceData.issueTickType == 1 &&
                detailSourceData.deliveryType == 4
              "
              >{{ detailSourceData.supplierOrderNo }}</span
            >
            <span class="content_bottom_label"
              >{{ TLang("订单编号", "list") }}：</span
            >
            <span class="content_bottom_value">
              {{ detailSourceData.mallShowGoodsOrderDtoList[0].orderNo }}
            </span>
            <span class="content_bottom_label content_bottom_margin"
              >{{ TLang("下单时间", "list") }}：</span
            >
            <span class="content_bottom_value">
              {{ detailSourceData.mallShowGoodsOrderDtoList[0].orderDate }}
            </span>
          </div>
        </div>
        <div class="pay_state_btn" v-if="pay_state == 1">
          <a
            href="javascript:;"
            class="state_btn_pay"
            @click="
              getOredrPay(detailSourceData.mallShowGoodsOrderDtoList[0].orderNo)
            "
            >{{ TLang("立即支付", "my") }}</a
          >
          <a
            href="javascript:;"
            class="state_btn_cancel"
            @click="getOrderCancel"
            >{{ TLang("取消订单", "list") }}</a
          >
        </div>
        <div
          class="pay_state_btn"
          v-if="
            detailSourceData.deliveryType == 2 &&
            (pay_state == 5 || pay_state == 8)
          "
        >
          <a href="javascript:;" class="state_btn_pay" @click="toLogstics">{{
            TLang("查看物流", "list")
          }}</a>
        </div>
      </div>
      <!-- <div class="tuipiao">
        <div class="title">退票收货地址</div>
        <Address></Address>
      </div>
      <div class="logInfo">
        <div class="top">
          <div class="title">物流信息</div>
          <div class="right">
            <div class="left">
              <span class="warning">!</span>为避免影响退票进度,请及时填写
            </div>
            <div class="left btn" @click="writeLogInfo">填写物流信息</div>
          </div>
        </div>

        <div class="logInfoShow">
          <div class="logInfo_line">
            <div class="logInfo_label">物流公司</div>
            <div class="logInfo_content">顺丰快递</div>
          </div>
          <div class="logInfo_line">
            <div class="logInfo_label">物流单号</div>
            <div class="logInfo_content">321431432</div>
          </div>
        </div>
      </div>-->
      <div class="ticket_info">
        <div
          class="yiqianshou"
          v-if="
            detailSourceData.receiveStatus == 3 &&
            detailSourceData.issueTickType == 1 &&
            detailSourceData.deliveryType == 4
          "
        >
          <img :src="staticAssets.ImgObj.isresave_img" alt />
        </div>
        <div class="confirm_title ticket_info_title">
          {{ TLang("取票信息", "my") }}
          <img
            :src="staticAssets.ImgObj.advance_sale_icon"
            alt
            class="confirm_title_icon"
            v-if="
              advance_flag &&
              pay_state == 8 &&
              detailSourceData.issueTickType != 1
            "
          />
          <span class="advance_info" v-if="advance_flag && pay_state != 8">{{
            TLang("本商品为预售商品", "my")
          }}</span>
          <img
            :src="staticAssets.ImgObj.ticket_success_icon"
            alt
            class="confirm_title_icon"
            v-if="
              (!advance_flag || pay_state == 8) &&
              (detailSourceData.issueTickType != 1 ||
                detailSourceData.deliveryType != 2)
            "
          />
          <span
            class="ticket_success_info"
            v-if="show_ticket_type == 1 && !advance_flag"
          >
            <span>{{ TLang("请前往", "my") }}</span>
            <el-popover
              placement="bottom"
              width="176"
              trigger="hover"
              popper-class="qr_code_show"
            >
              <img :src="staticAssets.ImgObj.dongfu_qrcode" alt />
              <p class="wei_text">{{ TLang("微信扫一扫东福公众号", "my") }}</p>
              <span class="doufu_qrcode" slot="reference">{{
                TLang("东方福利网公众号", "my")
              }}</span>
            </el-popover>

            <span
              >——【{{ TLang("个人中心", "home") }}】——【{{
                TLang("演出订单", "my")
              }}】{{ TLang("中查看", "my") }}【{{ TLang("电子码", "my") }}】{{
                TLang("哦", "my")
              }}~</span
            >
          </span>
          <span
            class="card_success_info"
            v-if="
              (!advance_flag &&
                show_ticket_type == 2 &&
                detailSourceData.issueTickType != 1) ||
              (advance_flag &&
                pay_state == 8 &&
                show_ticket_type == 2 &&
                detailSourceData.issueTickType != 1)
            "
            >{{ TLang("请带好身份证凭身份证入场", "my") }}</span
          >
          <!-- 上门自取展示 -->
          <span
            class="card_success_info"
            v-if="
              (!advance_flag &&
                detailSourceData.issueTickType == 1 &&
                detailSourceData.deliveryType == 4) ||
              (advance_flag &&
                detailSourceData.issueTickType == 1 &&
                detailSourceData.deliveryType == 4 &&
                pay_state == 8)
            "
            >{{TLang(detailSourceData.supplierCode === 1 ? '出票成功后手机号' : '猫眼出票成功后手机号','my')}}</span
          >
        </div>
        <ticket-type :sourceData="detailSourceData" ref="ticketType" />

        <!-- 取票人样式 ,快递配送不展示-->
        <div
          class="border_br"
          v-if="
            !(
              table_source.issueTicketType == 1 &&
              detailSourceData.deliveryType == 2
            )
          "
        ></div>
        <div
          v-if="
            !(
              table_source.issueTicketType == 1 &&
              detailSourceData.deliveryType == 2
            )
          "
        >
          <getTicketCom :ticketTableData="ticketTableData" />
        </div>
        <!-- 收货地址样式 -->
        <div
          class="border_br"
          v-if="
            table_source.issueTicketType == 1 &&
            detailSourceData.deliveryType == 2
          "
        ></div>

        <div
          v-if="
            table_source.issueTicketType == 1 &&
            detailSourceData.deliveryType == 2
          "
        >
          <Address
            :receiveAddress="detailSourceData.receiveAddress"
            :receiveMobile="detailSourceData.receiveMobile"
            :receiveName="detailSourceData.receiveName"
            :receiveIdNo="detailSourceData.receiveIdNo"
          ></Address>
        </div>

        <!-- 一票一证才有观演人展示 -->
        <div
          class="border_br"
          v-if="
            detailSourceData &&
            detailSourceData.mallShowGoodsOrderDtoList &&
            detailSourceData.mallShowGoodsOrderDtoList[0].realNameRegType == 2
          "
        ></div>
        <div
          v-if="
            detailSourceData &&
            detailSourceData.mallShowGoodsOrderDtoList &&
            detailSourceData.mallShowGoodsOrderDtoList[0].realNameRegType == 2
          "
        >
          <DramaWatcher :tickets="detailSourceData.tickets" />
        </div>

        <!-- 上门自取取票地址展示 -->
        <div
          class="border_br"
          v-if="
            table_source.issueTicketType == 1 &&
            detailSourceData.deliveryType == 4 &&
            cardTableLocation.length
          "
        ></div>
        <div
          class="ticket_info_user ticket_info_location"
          v-if="
            (table_source.issueTicketType == 1 &&
              detailSourceData.deliveryType == 4) ||
            detailSourceData.deliveryType == 3
          "
        >
          <ticket-location
            :locationSource="cardTableLocation"
            :locationAll="cardTableLocation"
            :type_ticket="
              detailSourceData.deliveryType == 3
                ? 1
                : detailSourceData.deliveryType == 4
                ? 2
                : 0
            "
            :detail_flag="1"
            ref="ticketLocation"
          />
        </div>
      </div>
      <div class="order_info">
        <div class="confirm_title order_info_title">
          {{ TLang("订单信息", "my") }}
        </div>
        <order-table
          :advanceFlag="advance_flag"
          :orderData="table_source"
          :orderPay="orderPay_flag"
          :evFlag="ev_flag"
          :supplierCode="detailSourceData.supplierCode"
          @toDetail="getToShopDetail"
        />
      </div>
      <div class="total_info">
        <div class="total_info_right">
          <div style="margin-bottom: 8px">
            <span style="color: #666666"
              >{{ TLang("商品总价", "my") }}({{
                JSON.stringify(unionInfo) != "{}" && unionInfo.name
                  ? unionInfo.name
                  : TLang("福豆", "card")
              }}):</span
            >
            <span
              style="
                color: rgba(17, 17, 17, 1);
                width: 99px;
                display: inline-block;
                font-size: 14px;
              "
            >
              {{
                unionInfo.scale
                  ? unionInfo.scale * table_source.totalPrice.toFixed(2)
                  : table_source.totalPrice.toFixed(2)
              }}
            </span>
          </div>
          <div v-if="mul_welfarePrice > 0" style="margin-bottom: 8px">
            <span style="color: #666666"
              >{{ TLang("优惠", "list") }}({{
                JSON.stringify(unionInfo) != "{}" && unionInfo.name
                  ? unionInfo.name
                  : TLang("福豆", "card")
              }}):</span
            >
            <span style="color: #666666; width: 99px; display: inline-block"
              >-{{
                unionInfo.scale
                  ? (unionInfo.scale * mul_welfarePrice).toFixed(2)
                  : mul_welfarePrice.toFixed(2)
              }}</span
            >
          </div>
          <div v-if="detailSourceData.freight" style="margin-bottom: 8px">
            <span style="color: #666666"
              >{{ TLang("运费", "my") }}({{
                JSON.stringify(unionInfo) != "{}" && unionInfo.name
                  ? unionInfo.name
                  : TLang("福豆", "card")
              }}):</span
            >
            <span
              style="
                color: rgba(17, 17, 17, 1);
                width: 99px;
                display: inline-block;
                font-size: 14px;
              "
            >
              {{
                unionInfo.scale
                  ? unionInfo.scale * detailSourceData.freight.toFixed(2)
                  : detailSourceData.freight.toFixed(2)
              }}
            </span>
          </div>
          <div v-if="detailSourceData.serviceFee" style="margin-bottom: 8px">
            <span style="color: #666666"
              >{{ TLang("平台服务费", "my") }}({{
                JSON.stringify(unionInfo) != "{}" && unionInfo.name
                  ? unionInfo.name
                  : TLang("福豆", "card")
              }}):</span
            >
            <span
              style="
                color: rgba(17, 17, 17, 1);
                width: 99px;
                display: inline-block;
                font-size: 14px;
              "
            >
              {{
                unionInfo.scale
                  ? unionInfo.scale * detailSourceData.serviceFee.toFixed(2)
                  : detailSourceData.serviceFee.toFixed(2)
              }}
            </span>
          </div>
          <div class="total_info_right_title">
            <span class="right_title_text"
              >{{
                pay_state == 1 ? TLang("需支付", "my") : TLang("合计", "my")
              }}：</span
            >
            <span class="new_total_style">
              <img
                :src="
                  unionInfo.icon
                    ? unionInfo.icon
                    : staticAssets.ImgObj.fudou_icon
                "
                alt
              />
              <span class="total_info_right_pay">
                {{
                  unionInfo.scale
                    ? (
                        (unionInfo.scale *
                          (Number(table_source.totalPrice) * 1000 +
                            (detailSourceData.serviceFee || 0) * 1000 +
                            detailSourceData.freight * 1000)) /
                        1000
                      ).toFixed(2)
                    : (
                        table_source.totalPrice +
                        detailSourceData.freight +
                        (detailSourceData.serviceFee || 0)
                      ).toFixed(2)
                }}
              </span>
            </span>
          </div>
        </div>
        <div class="pay_info_list" v-if="pay_state != 1 && test_pay.length > 0">
          <div class="pay_info_list_title">{{ TLang("支付明细", "list") }}</div>
          <pay-table :sourceData="test_pay" :payOrRefund="payOrRefund_pay" />
        </div>
        <div class="refund_br" v-if="test_refund.length > 0"></div>
        <div class="pay_info_list" v-if="test_refund.length > 0">
          <div class="pay_info_list_title">{{ TLang("退款明细", "list") }}</div>
          <pay-table
            :sourceData="test_refund"
            :payOrRefund="payOrRefund_refund"
          />
        </div>
      </div>
    </div>
    <el-dialog
      :title="TLang('物流信息', 'address')"
      :visible.sync="inputLogInfo"
      class="logDialog"
      width="528px"
      center
    >
      <el-form :model="logForm" ref="logForm" label-width="92px">
        <el-form-item :label="TLang('快递公司', 'my')" prop="kuaidiName">
          <el-input
            type="text"
            v-model="logForm.kuaidiName"
            autocomplete="off"
            :placeholder="TLang('请填写快递公司', 'my')"
          ></el-input>
        </el-form-item>
        <el-form-item label="快递单号" prop="orderNum" style="margin-top: 20px">
          <el-input
            type="text"
            v-model="logForm.orderNum"
            autocomplete="off"
            placeholder="请填写快递单号"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="btnWrap">
        <div class="logInfoBtn baocun">{{ TLang("保存", "list") }}</div>
        <div class="logInfoBtn quxiao">{{ TLang("取消", "address") }}</div>
      </div>
    </el-dialog>
    <el-dialog
      title
      :visible.sync="confirmVisible"
      class="confirm_dialog"
      width="420px"
      center
    >
      <div slot="title" class="header-title">
        <span class="title-del title_confirm_del" @click="getDelClose">
          <img :src="staticAssets.ImgObj.pop_del_icon" alt />
        </span>
      </div>
      <div class="confirm_top">
        <img :src="staticAssets.ImgObj.confirm_error_img" alt />
        <div class="confirm_text confirm_text_error">
          {{ TLang("您要取消该订单吗", "address") }}
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="dialog_btn dialog_confirm"
          type="primary"
          @click="confirmVisible = false"
          >{{ TLang("暂不取消", "my") }}</el-button
        >
        <el-button
          class="dialog_btn dialog_cancel"
          @click="confirmCancelOrder"
          >{{ TLang("取消订单", "list") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "OrderPay",

  components: {
    ticketType: () => import("@/components/TicketType/index.vue"), // 票品类型
    DramaWatcher: () => import("@/components/dramaWatcher/index.vue"),
    Address: () => import("@/components/addressShow/index.vue"), //地址展示组件
    orderTable: () => import("./OrderInfo.vue"), //订单信息table
    payTable: () => import("./PayInfo.vue"), //支付明细信息
    getTicketCom: () => import("@/components/getTicketCom/index.vue"), //取票人组件
    ticketLocation: () => import("./TicketLocation.vue"), //自取取票地址
  },

  data() {
    return {
      cardTableLocation: [],
      logForm: {
        kuaidiName: "",
        orderNum: "",
      },
      logRules: {
        kuaidiName: [
          { required: true, message: "请输入快递公司名称", trigger: "blur" },
        ],
        orderNum: [
          { required: true, message: "请输入快递单号", trigger: "blur" },
        ],
      },
      inputLogInfo: false, //控制填写物流信息开关
      detailSourceData: {}, //订单详情数据
      orderImg: {
        wait_pay: require("@/assets/imgs/wait_pay.png"),
      },
      table_source: {}, //order table的数据
      pay_state: null, //支付状态
      payOrRefund_pay: 1, //1支付、2退款
      payOrRefund_refund: 2, //1支付、2退款
      show_ticket_type: 2, //1电子票、2身份证
      advance_flag: false, //是否预售
      ticketSuccess_flag: false, //是否支付成功
      wait_pay_time: "", //待支付倒计时
      confirmVisible: false, //confirm的dialog开关
      queryData: {}, //query中的数据
      orderPay_flag: true, //是否是订单详情页面的订单信息
      mul_welfarePrice: 0, //优惠的价格
      order_statusName: "",
      ticketTableData: {},
      test_pay: [],
      test_refund: [],
      ev_flag: null,
    };
  },

  beforeCreate() {
    //开启加载动画
    //this.publicMethod.openLoading();
  },

  created() {
    this.queryData = this.$route.query;
    //获取订单详情信息
    this.getOrderDetail();
    const { VUE_APP_FLAG } = process.env;
    if (VUE_APP_FLAG === "pro" || VUE_APP_FLAG === "stage") {
      this.ev_flag = 1;
    } else {
      this.ev_flag = 2;
    }
  },

  // 移除滚动事件
  destroyed() {
    //window.removeEventListener("scroll", this.handleScroll, true);
  },

  computed: {
    ...mapState({
      unionInfo: "unionInfo",
    }),
  },

  methods: {
    writeLogInfo() {
      this.inputLogInfo = true;
    },
    toLogstics() {
      // 跳转物流详情
      this.$router.push({
        path: "/logstics",
        query: {
          orderNo: this.$route.query.orderNo,
        },
      });
    },
    //删除的关闭
    getDelClose() {
      this.confirmVisible = false;
    },
    //去逛逛 返回首页
    goToIndex() {
      this.$router.push({
        path: "/",
      });
    },
    // 返回订单列表页
    goToList() {
      this.$router.push({
        path: !this.$route.query.union
          ? "/order/list"
          : "/order/unionorderlist",
        query: !this.$route.query.union
          ? {
              city: this.$route.query.city,
            }
          : {
              city: this.$route.query.city,
              union: this.$route.query.union,
            },
      });
    },
    //获取订单详情数据
    getOrderDetail() {
      let detailSource = {
        orderNo: this.queryData.orderNo,
      };
      this.apis.showOrder.getDetailOrder(detailSource).then((res) => {
        if (!res.code) {
          this.detailSourceData = res.body;
          let goods_tableInfo = res.body.mallShowGoodsOrderDtoList; //订单信息
          //deliveryType  取票方式判断
          switch (res.body.deliveryType) {
            case 3:
              this.getMachineLocation(); //deliveryType ==3 自助机取票
              break;
            case 4:
              this.getSelfTake(res.body); //deliveryType ==4 上门自取地址
              break;
          }
          //获取订单信息
          if (!goods_tableInfo || goods_tableInfo.length < 1) {
            this.table_source = {};
          } else {
            this.assembleOrderInfo(goods_tableInfo);
          }
          //开启倒计时
          this.getTimeBack(goods_tableInfo[0].remainingTime);
          //当前支付状态
          this.pay_state = goods_tableInfo[0].orderStatus;
          //当前票种类型 2 是 身份证电子票 1 是电子票  3 是纸质票
          this.show_ticket_type =
            res.body.tickets[0].performIssueTicketType == 4 &&
            goods_tableInfo[0].realNameRegType
              ? 2
              : 1;
          if (res.body.tickets[0].performIssueTicketType == 1) {
            this.show_ticket_type = 3; //纸质票
          }
          this.order_statusName = goods_tableInfo[0].orderSubStatusName;
          //赋值用户信息
          this.ticketTableData = {
            receiveName: this.detailSourceData.receiveName,
            receiveMobile: this.detailSourceData.receiveMobile,
            receiveIdNo: this.detailSourceData.receiveIdNo,
          };
          //是否出票成功
          this.ticketSuccess_flag =
            goods_tableInfo[0].orderStatusName == "出票成功" ||
            goods_tableInfo[0].orderStatusName == "已完成"
              ? true
              : false;
          //是否预售
          this.advance_flag =
            goods_tableInfo[0].projectType == 0 ? false : true;
          //赋值支付明细信息
          this.test_pay =
            !res.body.mallPaymentDetails ||
            res.body.mallPaymentDetails.length < 1
              ? []
              : res.body.mallPaymentDetails;
          //赋值退款明细信息
          this.test_refund =
            !res.body.mallRefundPaymentDetails ||
            res.body.mallRefundPaymentDetails.length < 1
              ? []
              : res.body.mallRefundPaymentDetails;
        }
      });
    },
    //当票品类型为自助机
    getMachineLocation() {
      let machine_params = {
        supplierId: this.detailSourceData.supplierCode, //供应商id， 大麦1
        goodsId: this.detailSourceData.mallShowGoodsOrderDtoList[0].goodsId,
        dfflRondaId: this.detailSourceData.tickets[0].ticketPerformId,
        supplierFetchTicketWayId: this.detailSourceData.tickets[0].supplierFetchTicketWayId,
      };
      this.apis.showOrder.getMachineSource(machine_params).then((data) => {
        if (!data.code) {
          this.cardTableLocation = data.body != null ? data.body : [];
          // if (data.body.length > 3) {
          //   this.cardTableLocation = data.body.slice(0, 3);
          // } else {
          //   this.cardTableLocation = data.body;
          // }
        }
      });
    },
    //当票品类型为上门自取
    getSelfTake(source_data) {
      let pickAddress = [];
      source_data.pickupAddressList.forEach((value) => {
        pickAddress.push(JSON.parse(value));
      });
      this.cardTableLocation = pickAddress || []; //上门自取地址
    },
    //组装订单信息
    assembleOrderInfo(source_data) {
      let goodsItem = {
        priceName: {},
        ticketPrice: [],
        quantity: [],
        seatInfo: [],
        seatInfoObj: {},
        totalPrice: 0,
        seatNum: null,
      };
      goodsItem.seatNum = source_data.length; // 赋值票档个数
      source_data.forEach((i, ssIndex) => {
        let arrTest = []; // 存储座位信息转换字段
        goodsItem.priceName[`level${ssIndex}`] = [];
        //标记是否是套票普通票 0普通票1套票
        if (i.priceType != 0) {
          this.mapTicketMulitiple(i);
          i.subPrices.forEach((j) => {
            goodsItem.priceName[`level${ssIndex}`].push(
              i.priceName + "—" + j.ticketPrice
            );
          });
        } else {
          goodsItem.priceName[`level${ssIndex}`].push(i.priceName);
        }
        goodsItem.ticketPrice.push(i.ticketPrice);
        goodsItem.totalPrice += i.totalPrice * 1000;
        //无座
        if (i.seatList.length < 1) {
          if (i.priceType != 0) {
            i.subPrices.forEach((j) => {
              goodsItem.seatInfo.push(TLang("无座", "my"));
              arrTest.push(TLang("无座", "my"));
            });
          } else {
            goodsItem.seatInfo = [TLang("无座", "my")];
            arrTest.push(TLang("无座", "my"));
          }
          goodsItem.seatInfoObj[`${ssIndex}`] = arrTest;
        } else {
          //有座
          i.seatList.forEach((j) => {
            goodsItem.seatInfo.push(
              `${TLang("看台", "my")}${j.seatFullName}`
            );
            arrTest.push(
              `${TLang("看台", "my")}${j.seatFullName}`
            );
          });
          goodsItem.seatInfoObj[`${ssIndex}`] = arrTest;
        }
        goodsItem.quantity.push(i.quantity);
      });
      goodsItem.totalPrice = goodsItem.totalPrice / 1000;
      this.table_source = Object.assign({}, source_data[0], goodsItem);
    },
    //当票品为套票时遍历套票信息
    mapTicketMulitiple(sourceData) {
      let mul_totalPrice = 0;
      let mul_ticket = sourceData.subPrices;
      mul_ticket = !mul_ticket || mul_ticket.length < 1 ? [] : mul_ticket;
      if (mul_ticket.length > 0) {
        mul_ticket.forEach((i) => {
          mul_totalPrice += i.count * i.ticketPrice;
        });
        this.mul_welfarePrice +=
          ((mul_totalPrice * 1000 - sourceData.ticketPrice * 1000) / 1000) *
          sourceData.quantity;
      }
    },
    //取消订单
    getOrderCancel() {
      this.confirmVisible = true;
    },
    //确认取消订单
    confirmCancelOrder() {
      let cancelData = {
        orderNo: this.detailSourceData.mallShowGoodsOrderDtoList[0].orderNo,
      };
      this.apis.showOrder.getCancelOrder(cancelData).then((res) => {
        if (!res.code) {
          this.publicMethod.getThrowInfo("订单取消成功", "success");
          this.confirmVisible = false;
          this.$nextTick(() => {
            this.getOrderDetail({ orderNo: this.queryData.orderNo });
          });
        }
      });
    },
    //跳转商品详情
    getToShopDetail(sId) {
      this.$router.push({
        path: "/detail",
        query: { id: sId },
      });
    },
    //立即支付
    getOredrPay(val) {
      let cancelData = {
        platform: 0, //平台0默认PC
        orderNo: val,
      };
      this.apis.showOrder.getPayOrder(cancelData).then((res) => {
        if (!res.code) {
          window.df_sdk_common.location.href = res.body.payUrl;
        }
      });
    },
    //倒计时
    getTimeBack(timeSource) {
      let m = 0,
        s = 0;
      let timeTotal =
        parseInt(timeSource / 1000) <= 0 ? 0 : parseInt(timeSource / 1000);
      if (timeTotal > 0) {
        let payTimer = setInterval(() => {
          m = parseInt(timeTotal / 60);
          s = timeTotal % 60;
          this.wait_pay_time = `00:${m < 10 ? "0" + m : m}:${
            s < 10 ? "0" + s : s
          }`;
          timeTotal--;
          if (timeTotal < 0) {
            window.clearInterval(payTimer);
            //默认出发取消订单
            //this.confirmCancelOrder();
            //刷新订单详情页面
            this.getOrderDetail();
          }
        }, 1000);
      } else {
        this.wait_pay_time = "00:00";
      }
    },
    //支付状态转换
    getPayStatus(val) {
      let payText = "";
      switch (val) {
        case 1:
          payText = TLang("待支付", "list");
          this.orderImg.wait_pay = require("@/assets/imgs/wait_pay.png");
          this.ticketSuccess_flag = false;
          break;
        case 2:
          payText = TLang("已支付", "my");
          this.orderImg.wait_pay = require("@/assets/imgs/paid.png");
          this.ticketSuccess_flag = false;
          break;
        case 4:
          payText = TLang("已取消", "my");
          this.orderImg.wait_pay = require("@/assets/imgs/pay_cancel.png");
          this.ticketSuccess_flag = false;
          break;
        case 5:
          payText = TLang("已完成", "my");
          this.orderImg.wait_pay = require("@/assets/imgs/pay_success.png");
          this.ticketSuccess_flag = true;
          break;
        case 7:
          payText = TLang("出票中", "my");
          this.orderImg.wait_pay = require("@/assets/imgs/ticket_making.png");
          this.ticketSuccess_flag = false;
          break;
        case 8:
          payText = TLang("出票成功", "my");
          this.orderImg.wait_pay = require("@/assets/imgs/ticket_success.png");
          this.ticketSuccess_flag = true;
          break;
        case 9:
          payText = TLang("申请退款", "list");
          this.orderImg.wait_pay = require("@/assets/imgs/apply_refund.png");
          this.ticketSuccess_flag = false;
          break;
        case 10:
          payText = TLang("退款申请成功", "list");
          this.orderImg.wait_pay = require("@/assets/imgs/apply_refund.png");
          this.ticketSuccess_flag = false;
          break;
        case 11:
          payText = TLang("退款成功", "my");
          this.orderImg.wait_pay = require("@/assets/imgs/apply_refund.png");
          this.ticketSuccess_flag = false;
          break;
        case 12:
          payText = TLang("退款申请失败", "my");
          this.orderImg.wait_pay = require("@/assets/imgs/fail_refund.png");
          this.ticketSuccess_flag = false;
          break;
        case 13:
          payText = TLang("退款失败", "my");
          this.orderImg.wait_pay = require("@/assets/imgs/fail_refund.png");
          this.ticketSuccess_flag = false;
          break;
      }
      return payText;
    },
  },
};
</script>

<style scoped lang="less">
.logInfo_line {
  .clearfix;
  margin-top: 18px;
  .logInfo_label {
    font-weight: normal;
    font-size: 14px;
    float: left;
    color: #999999;
    margin-right: 48px;
  }
  .logInfo_content {
    float: left;
    font-weight: normal;
    font-size: 14px;
  }
}
.logInfoBtn {
  float: left;
  width: 120px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin-top: 20px;
  cursor: pointer;
}
.baocun {
  background: linear-gradient(
    315deg,
    rgba(92, 180, 236, 1) 0%,
    rgba(61, 150, 226, 1) 100%
  );
  border-radius: 4px;
  color: #fff;
  margin-left: 100px;
}
.btnWrap {
  .clearfix;
}
.quxiao {
  border-radius: 4px;
  border: 1px solid rgba(229, 229, 229, 1);
  float: left;
  margin-left: 20px;
}
/deep/ .logDialog .el-dialog__body .el-input {
  width: 350px;
  height: 32px;
  .el-input__inner {
    .drama_wrap_attr(100%, 100%, 32px, 12px, rgba(17, 17, 17, 1));
    padding: 0 12px;
  }
}
/deep/ .logDialog .el-form-item__label {
  font-size: 14px;
  color: #666666;
  padding-right: 32px;
}
/deep/ .logDialog .el-dialog__body {
  padding: 24px 40px;
}
.logInfo {
  padding: 24px;
  font-size: 20px;
  font-weight: bold;
  margin-top: 24px;
  color: #333333;
  border: 1px solid #e5e5e5;
  .top {
    .clearfix;
  }
  .warning {
    .drama_wrap_attr(14px, 14px, 14px, inherit, white);
    border-radius: 10px;
    background-color: #ffaf00;
    display: block;
    float: left;
    text-align: center;
    margin-top: 2px;
    margin-right: 4px;
  }
  .title {
    float: left;
  }
  .clearfix;
  .right {
    float: right;
    .clearfix;
  }
  .left {
    float: left;
    font-size: 12px;
    color: #ffaf00;
    background: rgba(255, 247, 229, 1);
    box-shadow: 0px 1px 2px 0px rgba(255, 175, 0, 0.24);
    padding: 8px 19px;
  }
  .btn {
    .drama_wrap_attr(112px, 40px, 40px, 14px, white);
    text-align: center;
    background: linear-gradient(
      315deg,
      rgba(92, 180, 236, 1) 0%,
      rgba(61, 150, 226, 1) 100%
    );
    border-radius: 4px;
    padding: 0;
    margin-left: 12px;
    position: relative;
    top: -2px;
    cursor: pointer;
  }
}
.tuipiao {
  padding: 24px;
  border: 1px solid #e5e5e5;
  .title {
    font-size: 20px;
    font-weight: bold;
  }
}
.dialog_btn {
  .drama_specs_unit(120px, 40px);
  border-radius: 4px;
  font-size: 14px;
}
.dialog_confirm {
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  background: linear-gradient(
    315deg,
    rgba(92, 180, 236, 1) 0%,
    rgba(61, 150, 226, 1) 100%
  );
  margin-right: 20px;
}
.dialog_cancel {
  border: 1px solid rgba(229, 229, 229, 1);
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.confirm_top {
  text-align: center;
  img {
    width: 68px;
    display: inline-block;
    vertical-align: middle;
  }
  .confirm_text {
    .drama_font_style(inherit, 400, 18px, 25px);
    margin: 18px auto 36px;
    color: rgba(51, 51, 51, 1);
  }
  .confirm_text_error {
    margin-top: 16px !important;
  }
}
/deep/ .el-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
}
/deep/ .el-dialog__header {
  font-size: 18px;
  color: rgba(17, 17, 17, 1);
  line-height: 24px;
  padding: 16px 20px;
  position: relative;
}
/deep/ .el-dialog__header::after {
  position: absolute;
  bottom: 0;
  left: 0;
  content: "";
  display: block;
  height: 1px;
  width: 528px;
  background: rgba(229, 229, 229, 1);
  box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.05);
}
/deep/ .confirm_dialog .el-dialog__header::after {
  height: 0;
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
}
/deep/ .el-dialog__body {
  padding: 0px 61px 4px;
}

.top_steps {
  margin: 16px 0;
  .click_point {
    cursor: pointer;
  }
  span {
    font-size: 12px;
    color: rgba(153, 153, 153, 1);
    line-height: 16px;
    display: inline-block;
  }

  .top_arrow_icon img {
    .drama_specs_unit(12px, 12px);
    margin: 2px 4px;
  }
}
.ticket_info {
  position: relative;
}
.yiqianshou {
  position: absolute;
  top: 0;
  right: 0;
  width: 140px;
}
.ticket_pay_state,
.ticket_info,
.order_info,
.total_info {
  border: 1px solid rgba(229, 229, 229, 1);
  margin-top: 24px;
  margin-bottom: 30px;
  box-sizing: border-box;
}
.ticket_pay_state {
  margin-top: 0;
  width: 100%;
  height: 164px;
  background: rgba(248, 252, 255, 1);
  padding: 28px 32px 0 34px;
  .pay_state_img,
  .pay_state_content {
    float: left;
  }

  .pay_state_img {
    width: 120px;
    height: 100%;
    margin-right: 41px;
    img {
      width: 100%;
      vertical-align: middle;
    }
  }

  .pay_state_content {
    font-size: 14px;
    img {
      .drama_specs_unit(14px, 14px);
      margin: 14px 4px 0 24px;
    }
    .content_top_label {
      .drama_font_style(inherit, bold, 24px, 31px);
      color: rgba(17, 17, 17, 1);
    }
    .content_top_paytime {
      color: rgba(102, 102, 102, 1);
      line-height: 19px;
    }
    .pay_state_cancel {
      margin-left: 24px;
    }
    .content_top_time {
      margin-left: 8px;
      color: rgba(244, 69, 69, 1);
      line-height: 17px;
    }
    .state_content_top {
      margin-top: 17px;
    }
    .state_content_bottom {
      margin-top: 24px;
      font-size: 14px;
      line-height: 19px;
    }
    .content_bottom_label {
      color: rgba(153, 153, 153, 1);
    }
    .content_bottom_margin {
      margin-left: 32px;
    }
    .content_bottom_value {
      color: rgba(17, 17, 17, 1);
    }
  }
  .pay_state_btn {
    float: right;
    a {
      .drama_wrap_attr(110px, 40px, 40px, 14px, inherit);
      display: block;
      border-radius: 4px;
      text-align: center;
    }
    .state_btn_pay {
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      margin: 6px 0 16px;
      background: linear-gradient(
        315deg,
        rgba(92, 180, 236, 1) 0%,
        rgba(61, 150, 226, 1) 100%
      );
    }
    .state_btn_cancel {
      color: rgba(127, 127, 127, 1);
      border: 1px solid rgba(221, 221, 221, 1);
    }
  }
}
.shouhuo {
  margin-top: 26px;
}
.total_info::after,
.ticket_pay_state::after {
  content: "";
  display: block;
  visibility: hidden;
  height: 0;
  clear: both;
}
.border_br {
  width: 100%;
  height: 1px;
  background: rgba(247, 247, 247, 1);
}
.refund_br {
  width: 100%;
  height: 1px;
  background: #e5e5e5;
}
.ticket_info {
  padding: 0 24px;
  .ticket_info_user {
    padding-top: 26px;
    box-sizing: border-box;
  }
}
.total_info {
  .total_info_right {
    padding: 28px 24px 28px 0;
    width: 100%;
    // height: 106px;
    background: rgba(248, 252, 255, 1);
    text-align: right;
    font-size: 12px;
    .total_info_right_title {
      color: rgba(102, 102, 102, 1);
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .new_total_style {
        width: 99px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
      .right_title_text {
        color: rgba(102, 102, 102, 1);
        line-height: 16px;
      }
      img {
        width: 15px;
        height: 15px;
        margin: 2px 2px 0 8px;
      }
    }
    .total_info_right_pay {
      .drama_font_style(inherit, bold, 20px, 24px);
      color: rgba(17, 17, 17, 1);
    }
  }
  .pay_info_list {
    .pay_info_list_title {
      padding: 24px 0 16px 24px;
      font-size: 16px;
      color: rgba(17, 17, 17, 1);
      line-height: 21px;
    }
  }
}
.confirm_title {
  .drama_font_style(inherit, bold, 20px, 26px);
  margin: 24px 0 25px 0;
  color: rgba(51, 51, 51, 1);
  .confirm_title_icon {
    width: 12px;
    height: 12px;
    display: inline-block;
    vertical-align: middle;
    margin: 0 4px 0 12px;
  }
  .advance_info {
    font-size: 12px;
    color: rgba(253, 29, 29, 1);
    line-height: 16px;
  }
  .ticket_success_info {
    span {
      display: inline-block;
      font-size: 12px;
      line-height: 16px;
      color: rgba(102, 102, 102, 1);
    }
    .doufu_qrcode {
      color: #3d96e2;
      cursor: pointer;
    }
  }
  .card_success_info {
    display: inline-block;
    font-size: 12px;
    line-height: 16px;
    color: rgba(102, 102, 102, 1);
  }
}

.order_info_title {
  padding: 0 24px;
}

* {
  margin: 0;
  padding: 0;
  color: #333333;
}
.order-wrap {
  width: 1200px;
  margin: 0 auto;
}

.info_left {
  align-items: center;
  display: flex;
}
/deep/ .el-dialog__footer {
  margin-bottom: 23px;
  padding-top: 0;
}
</style>
<style lang="less">
* .dialog_confirm {
  span {
    font-weight: bold !important;
    display: inline-block;
  }
}
.header-title .title-del {
  width: 28px;
  height: 28px;
  background: #ffffff;
  position: absolute;
  right: 11px;
  top: 11px;
  z-index: 99;
  cursor: pointer;
  img {
    width: 16px;
    height: 16px;
    display: inline-block;
    vertical-align: middle;
  }
}
.qr_code_show {
  text-align: center !important;
  padding: 18px !important;
  padding-bottom: 15px !important;
}
.qr_code_show .wei_text {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  line-height: 16px;
  padding: 6px 8px 0px;
}
.qr_code_show img {
  width: 140px;
  height: 140px;
  display: inline-block;
  vertical-align: middle;
}
</style>
